module.exports = __webpack_public_path__ + "static/img/cabinet24_18.155f753c.gif";